var dropZone = 'drop-zone_dropZone__bvuf5q0';

export { dropZone };
//# sourceMappingURL=drop-zone.vanilla.mjs.map
